<div [ngSwitch]='data.tag' class='modal-content-wrap responses-pop RContent'>
  <ng-container *ngIf='showLoadingSpinner; else content'>
    <div class='d-flex justify-content-center'>
      <mat-spinner class='blue-spinner'></mat-spinner>
    </div>
  </ng-container>
  <ng-template #content>
    <form *ngIf='formReady' [formGroup]='formGroup'>
      <!--      Enter activity-->
      <div *ngSwitchCase="'enter_activity'">
        <div class='RContent-row'>
          <mat-label>Type:</mat-label>
          <mat-radio-group
            aria-label='Select an activity type'
            formControlName='action'>
            <mat-radio-button class='ms-2' value='phone'
            >Phone call
            </mat-radio-button
            >
            <mat-radio-button class='ms-2' value='note'>Note</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class='RContent-row'>
          <mat-label>Title</mat-label>
          <app-text-field
            formControlName='subject'
            placeholder='Title'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>Message</mat-label>
          <app-editor (ready)='onEditorReady()' [initOverrides]='editorConfig' formControlName='message'></app-editor>
        </div>
      </div>
      <!--      End: Enter activity-->
      <!--Inactive-->
      <div *ngSwitchCase="'inactive'">
        <div *ngIf='cc && cc.length' class='RContent-row'>
          <mat-label>Add more recipients</mat-label>
          <app-select [items]='cc' [multi]='true' formControlName='cc_to' label='CC'></app-select>
        </div>
        <div class='RContent-row'>
          <mat-label>Reason:</mat-label>
          <mat-radio-group
            (change)='onInactiveReasonChange($event)'
            aria-label='Select an inactive reason'
            formControlName='action'>
            <mat-radio-button class='ms-2' value='Wrong Contact'
            >Wrong Contact
            </mat-radio-button
            >
            <mat-radio-button class='ms-2' value='Not a good fit'
            >Not a good fit
            </mat-radio-button
            >
            <mat-radio-button class='ms-2' value='Out of business'
            >Out of business
            </mat-radio-button
            >
            <mat-radio-button class='ms-2' value='Other'
            >Other
            </mat-radio-button
            >
          </mat-radio-group>
          <app-text-field
            #inactiveCustomReasonField
            *ngIf="getControl('action').value == 'Other'"
            formControlName='custom_reason'
            placeholder='Write your custom reason here'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>Message:</mat-label>
          <app-editor (ready)='onEditorReady()' [initOverrides]='editorConfig' formControlName='message'></app-editor>
        </div>
        <app-html-viewer [html]='signature' class='RContent-row'></app-html-viewer>
      </div>
      <!--Remove-->
      <div *ngSwitchCase="'remove'">
        <div class='RContent-row'>
          <mat-label>Add more recipients</mat-label>
          <app-select [items]='cc' [multi]='true' formControlName='cc_to' label='CC'></app-select>
        </div>
        <div class='RContent-row'>
          <mat-label>Message</mat-label>
          <app-editor (ready)='onEditorReady()' [initOverrides]='editorConfig' formControlName='message'></app-editor>
        </div>
        <app-html-viewer [html]='signature' class='RContent-row'></app-html-viewer>
      </div>
      <!--Conversation-->
      <div *ngSwitchCase="'conversation'">
        <div class='RContent-row'>
          <mat-label>To</mat-label>
          <app-text-field
            formControlName='to'
            placeholder='To'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>Add more recipients</mat-label>
          <app-select [items]='cc' [multi]='true' formControlName='cc_to' label='CC'></app-select>
        </div>
        <div class='RContent-row'>
          <mat-label>Subject</mat-label>
          <app-text-field
            formControlName='subject'
            placeholder='Subject'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>Message</mat-label>
          <app-editor #conversationEditor (ready)='onEditorReady()' [initOverrides]='editorConfig' formControlName='message'></app-editor>
        </div>
        <div class='RContent-row upload-section'>
          <mat-form-field>
            <div>
              <mat-toolbar class='input-bar'>
                <!-- Display files names -->
                <input formControlName='name' matInput name='name' readonly />
                <!-- Browse Button -->
                <app-button
                  [color]='buttonColors.BLUE'
                  [style]="'outline'"
                  size='small'
                  text='Browse File'></app-button>
              </mat-toolbar>

              <!-- Fetch selected filed on change -->
              <input
                #fileInput
                (change)='uploadFileEvt($event)'
                accept='image/*'
                class='upload-file-input'
                id='uploadFileConversation'
                multiple='multiple'
                name='uploadFile'
                type='file' />
            </div>
          </mat-form-field>
        </div>
      </div>
      <!--Custom email 1-->
      <div *ngSwitchCase="'custom_email_1'">
        <div class='RContent-row'>
          <mat-label>To</mat-label>
          <app-text-field
            formControlName='to'
            placeholder='To'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>Subject</mat-label>
          <app-text-field
            formControlName='subject'
            placeholder='Subject'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>Message</mat-label>
          <app-editor (ready)='onEditorReady()' [initOverrides]='editorConfig' formControlName='message'></app-editor>
        </div>
        <div class='RContent-row upload-section'>
          <mat-form-field>
            <div>
              <mat-toolbar class='input-bar'>
                <!-- Display files names -->
                <input formControlName='name' matInput name='name' readonly />
                <!-- Browse Button -->
                <app-button
                  [color]='buttonColors.BLUE'
                  [style]="'outline'"
                  size='small'
                  text='Browse File'></app-button>
              </mat-toolbar>
              <!-- Fetch selected filed on change -->
              <input
                #fileInput
                (change)='uploadFileEvt($event)'
                accept='image/*'
                class='upload-file-input'
                id='uploadFileCustomEmail1'
                multiple='multiple'
                name='uploadFile'
                type='file' />
            </div>
          </mat-form-field>
        </div>
      </div>
      <!-- Send Email-->
      <div *ngSwitchCase="'send-email'">
        <div class='RContent-row'>
          <mat-label>To</mat-label>
          <app-text-field
            formControlName='to'
            placeholder='To'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>CC</mat-label>
          <app-text-field
            formControlName='cc_to'
            placeholder='CC'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>Subject</mat-label>
          <app-text-field
            formControlName='subject'
            placeholder='Subject'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>Message</mat-label>
          <app-editor (ready)='onEditorReady()' [initOverrides]='editorConfig' formControlName='message'></app-editor>
        </div>
        <div class='RContent-row upload-section'>
          <mat-form-field>
            <div>
              <mat-toolbar class='input-bar'>
                <!-- Display files names -->
                <input formControlName='name' matInput name='name' readonly />
                <!-- Browse Button -->
                <app-button
                  [color]='buttonColors.BLUE'
                  [style]="'outline'"
                  size='small'
                  text='Browse File'></app-button>
              </mat-toolbar>

              <!-- Fetch selected filed on change -->
              <input
                #fileInput
                (change)='uploadFileEvt($event)'
                accept='image/*'
                class='upload-file-input'
                id='uploadFileSendEmail'
                multiple='multiple'
                name='uploadFile'
                type='file' />
            </div>
          </mat-form-field>
        </div>
      </div>
      <!--follow up-->
      <div *ngSwitchCase="'followup'">
        <mat-horizontal-stepper
          #stepper
          (selectionChange)='onSelectionChange($event)'
          *ngIf='dataReady'
          [class.stepper-click-disabled]='true'
          [linear]='isLinear'>
          <mat-step [stepControl]='formGroup'>
            <ng-template matStepLabel>Step 1</ng-template>
            <ng-template matStepContent>
              <div class='RContent-row'>
                <mat-label>Add more recipients</mat-label>
                <app-select [items]='cc' [multi]='true' formControlName='cc_to' label='CC'></app-select>
              </div>
              <div class='RContent-row'>
                <mat-label>Subject</mat-label>
                <app-text-field
                  formControlName='subject'
                  placeholder='Subject'></app-text-field>
              </div>
              <div class='RContent-row'>
                <mat-label>Date</mat-label>
                <app-text-field
                  (changes)='onFollowUpDateChange()'
                  [datePickerStartDate]='getStartDate()'
                  datePickerType='calendar'
                  formControlName='action'
                  placeholder='Date'
                  type='date'></app-text-field>
                <mat-hint>Select date for Future Follow Up.</mat-hint>
              </div>
              <div class='RContent-row'>
                <mat-label>Message</mat-label>
                <app-editor (ready)='onEditorReady()' [initOverrides]='editorConfig'
                            formControlName='message'></app-editor>
              </div>
              <div class='RContent-row upload-section'>
                <mat-form-field>
                  <div>
                    <mat-toolbar class='input-bar'>
                      <!-- Display files names -->
                      <input formControlName='name' matInput name='name' readonly />
                      <!-- Browse Button -->
                      <app-button
                        [color]='buttonColors.BLUE'
                        [style]="'outline'"
                        size='small'
                        text='Browse File'></app-button>
                    </mat-toolbar>

                    <!-- Fetch selected filed on change -->
                    <input
                      #fileInput
                      (change)='uploadFileEvt($event)'
                      accept='*/*'
                      class='upload-file-input'
                      id='uploadFileFollowup'
                      multiple='multiple'
                      name='uploadFile'
                      type='file' />
                  </div>
                </mat-form-field>
              </div>
              <app-html-viewer [html]='signature' class='RContent-row'></app-html-viewer>
            </ng-template>
          </mat-step>
          <mat-step>
            <ng-template matStepLabel>Follow Up 1</ng-template>
            <ng-template matStepContent>
              <div class='RContent-row'>
                <mat-label>First Scheduled Follow Up</mat-label>
                <app-editor (ready)='onEditorReady()' [initOverrides]='editorConfig'
                            formControlName='future_message_1'></app-editor>
              </div>
              <div class='RContent-row flex-row align-items-end'>
                <mat-label>Use Text for follow up 2 and 3:</mat-label>
                <mat-checkbox
                  (change)='refresh()'
                  class='same_message ms-3'
                  color='primary'
                  formControlName='same_message'
                  id='same_message'></mat-checkbox>
              </div>
              <app-html-viewer [html]='signature' class='RContent-row'></app-html-viewer>
            </ng-template>
          </mat-step>
          <mat-step *ngIf='!formGroup.controls.same_message.value'>
            <ng-template matStepLabel>Follow Up 2</ng-template>
            <ng-template matStepContent>
              <div class='RContent-row'>
                <mat-label>Second Scheduled Follow Up</mat-label>
                <app-editor (ready)='onEditorReady()' *ngIf='stepper.selectedIndex == 2' [initOverrides]='editorConfig'
                            formControlName='future_message_2'></app-editor>
              </div>
              <app-html-viewer [html]='signature' class='RContent-row'></app-html-viewer>
            </ng-template>
          </mat-step>
          <mat-step *ngIf='!formGroup.controls.same_message.value'>
            <ng-template matStepLabel>Follow Up 3</ng-template>
            <ng-template matStepContent>
              <div class='RContent-row'>
                <mat-label>Third Scheduled Follow Up</mat-label>
                <app-editor (ready)='onEditorReady()' *ngIf='stepper.selectedIndex == 3' [initOverrides]='editorConfig'
                            formControlName='future_message_3'></app-editor>
                >
              </div>
              <app-html-viewer [html]='signature' class='RContent-row'></app-html-viewer>
            </ng-template>
          </mat-step>
        </mat-horizontal-stepper>
      </div>
      <!--Cycle-->
      <div *ngSwitchCase="'cycle'">
        <mat-horizontal-stepper class="stepper-click-disabled" #stepper (selectionChange)='onSelectionChange($event)' *ngIf='dataReady'
                                [linear]='isLinear'>
          <mat-step [stepControl]='formGroup'>
            <ng-template matStepLabel>Step 1</ng-template>
            <ng-template matStepContent>
              <div *ngIf='cc && cc.length' class='RContent-row'>
                <mat-label>Add more recipients</mat-label>
                <app-select [items]='cc' [multi]='true' formControlName='cc_to' label='CC'></app-select>
              </div>
              <div class='RContent-row'>
                <mat-label>Subject</mat-label>
                <app-text-field
                  formControlName='subject'
                  placeholder='Subject'></app-text-field>
              </div>
              <div class='RContent-row'>
                <mat-label>Duration</mat-label>
                <mat-radio-group
                  (change)='onDurationChange($event)'
                  aria-label='Select a duration'
                  formControlName='action'>
                  <mat-radio-button
                    *ngFor='let period of cyclePeriodOptions'
                    class='ms-2'
                    [value]="'' + period"
                  >{{ period }} {{ period == 1 ? 'month' : 'Months' }}
                  </mat-radio-button>
                </mat-radio-group>
                <app-button
                  *ngIf='userData?.user_type === UserType.SINGLE_USER'
                  class='ms-3'
                  [color]='buttonColors.BLUE'
                  [style]="'outline'"
                  size='small'
                  text='Set default'
                  (clicked)='setDefaultCyclePeriod()'
                  [disabled]='settingDefaultCyclePeriod'></app-button>
              </div>
              <div class='RContent-row'>
                <mat-label>Message</mat-label>
                <app-editor (ready)='onEditorReady()' [initOverrides]='editorConfig'
                            formControlName='message'></app-editor>
              </div>
              <app-html-viewer [html]='signature' class='RContent-row'></app-html-viewer>
            </ng-template>
          </mat-step>
          <mat-step [stepControl]='formGroup'>
            <form [formGroup]='formGroup'>
              <ng-template matStepLabel>Preview</ng-template>
              <ng-template matStepContent>
                <div class='RContent-row'>
                  <mat-label>Future subject</mat-label>
                  <app-text-field
                    formControlName='future_subject'
                    placeholder='Future subject'></app-text-field>
                </div>
                <div class='RContent-row'>
                  <mat-label>Message</mat-label>
                  <app-editor (ready)='onEditorReady()' [initOverrides]='editorConfig'
                              formControlName='future_message'></app-editor>
                </div>
                <app-html-viewer [html]='signature' class='RContent-row'></app-html-viewer>
              </ng-template>
            </form>
          </mat-step>
        </mat-horizontal-stepper>
      </div>
      <!--Opportunities -Meeting-->
      <div *ngSwitchCase="'meeting'">
        <div class='RContent-row'>
          <mat-label>Recipients</mat-label>
          <app-text-field
            formControlName='cc_to'
            placeholder='Recipients'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>Date</mat-label>
          <app-text-field
            (changes)='onStartDateChange($event)'
            datePickerType='calendar'
            formControlName='action'
            placeholder='Date'
            type='date'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>Start</mat-label>
          <app-text-field
            (changes)='onStartDateChange($event)'
            [minutesSteps]='15'
            datePickerType='timer'
            formControlName='start_time'
            placeholder='Start time'
            type='date'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>End</mat-label>
          <app-text-field
            [minutesSteps]='15'
            datePickerType='timer'
            formControlName='end_time'
            placeholder='End time'
            type='date'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>Location</mat-label>
          <app-text-field
            formControlName='location'
            placeholder='Location'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>Subject</mat-label>
          <app-text-field
            formControlName='subject'
            placeholder='Subject'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>Message</mat-label>
          <app-editor (ready)='onEditorReady()' [initOverrides]='editorConfig' formControlName='message'></app-editor>
        </div>
      </div>
      <!--Opportunities - order -->
      <div *ngSwitchCase="'order'">
        <div class='RContent-row flex-row align-items-end'>
          <mat-label>This is a quote:</mat-label>
          <mat-checkbox
            class='quote ms-3'
            color='primary'
            formControlName='quote'
            id='quote'></mat-checkbox>
        </div>
        <div class='RContent-row'>
          <mat-label>{{
              getControl('quote').value == true
                ? 'Estimate Closing Date'
                : 'Date Closed'
            }}
          </mat-label>
          <app-text-field
            datePickerType='calendar'
            formControlName='action'
            placeholder='Date'
            type='date'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>Product :</mat-label>
          <app-select
            [items]='getProductsItems()'
            formControlName='product_id'
            label='Product'></app-select>
        </div>
        <div class='RContent-row'>
          <mat-label>{{
              getControl('quote').value === true
                ? 'Estimate value ($)'
                : 'Amount of sale ($)'
            }}
          </mat-label>
          <app-text-field
            formControlName='amount'
            placeholder='Amount'></app-text-field>
        </div>
        <div class='RContent-row'>
          <mat-label>Note</mat-label>
          <app-editor (ready)='onEditorReady()' [initOverrides]='editorConfig' formControlName='message'></app-editor>
        </div>
      </div>
    </form>
  </ng-template>
</div>
